import restAPI from '@/utils/rest-api'
export default {
    submitPageView(pageTitle, pageUrl, routeParams) {
        return restAPI.post('/page-views/submit-page-view', { pageTitle, pageUrl, routeParams })
    }
}
